import { Providers } from './accounting-report.interface';

export interface AirlineRule {
    id: number;
    airlineCodes: string[];
    provider: Providers;
    agent: {
        id: number;
        code: string;
        name: string;
    };
    providerSupplier: ProviderSupplier;
    active: boolean;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    ruleType: string;
}
export interface AirlineRuleRequest {
    airlineCodes: string[];
    providerId: number;
    agentId: number;
    providerSupplierId: number | null;
    ruletype: RuleType;
}
export enum RuleType {
    RESTRICTED = 'RESTRICTED',
    ALLOWED = 'ALLOWED'
}
export interface Agent {
    id: number;
    code: string;
    name: string;
}
export interface ProviderSupplier {
    id: number;
    supplierName: string;
    supplierId: string;
    providerId: number;
}
